import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import getTradingCompanyName from '../../utils/getTradingCompanyName';
import { LANGUAGE } from '../../constants';
import type { ICellRendererParams } from 'ag-grid-community';
import type { Language } from '../../types/common';

const TradingCompanyCodeCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params.column.getColId());
  // colIdは国内なら「商社コード_数字」、輸出なら「tradingCompanyCode」になるのでこれで国内・輸出を判定する
  const colId: string = params.column.getColId();
  const language: Language | '' = colId.indexOf('商社コード') > -1 ? LANGUAGE.JA : colId.indexOf('tradingCompanyCode') > -1 ? LANGUAGE.EN : '';
  const tradingCompanyCode: string = params.value;
  const { tradingCompany } = useSelector((state: RootState) => state.options);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    // 商社コードを商社名にマップする。マッチするものが見つからなかったらコードのままにする。
    const name: string = language !== '' ? getTradingCompanyName(tradingCompanyCode, { tradingCompanies: tradingCompany, language }) : tradingCompanyCode;
    // console.log(name);
    setDisplayName(name);
  }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="trading-company-code">{displayName}</span>;
};

export default TradingCompanyCodeCellRenderer;
